// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { foodSensoryRoundId } from './FoodSensoryRound';
import { foodSensoryQuestionId } from './FoodSensoryQuestion';
import { foodSensoryTestType } from './FoodSensoryTestType';
import { foodSensoryQuestionType } from './FoodSensoryQuestionType';
import { z } from 'zod';
export const foodSensoryRoundQuestionId = (z.number());
export const foodSensoryRoundQuestion = z.object({
    id: foodSensoryRoundQuestionId,
    round_id: foodSensoryRoundId,
    source_question_id: foodSensoryQuestionId.nullable(),
    test_type: foodSensoryTestType,
    text: z.string(),
    question_type: foodSensoryQuestionType,
    options: z.unknown().nullable(),
    min_value: z.number(),
    max_value: z.number(),
    min_label: z.string().nullable(),
    max_label: z.string().nullable(),
    display_order: z.number(),
    required: z.boolean(),
    is_headline: z.boolean(),
    created_at: z.date(),
    customized_at: z.date().nullable(),
    removed_at: z.date().nullable(),
});
export const foodSensoryRoundQuestionInitializer = z.object({
    id: foodSensoryRoundQuestionId.optional(),
    round_id: foodSensoryRoundId,
    source_question_id: foodSensoryQuestionId.optional().nullable(),
    test_type: foodSensoryTestType,
    text: z.string(),
    question_type: foodSensoryQuestionType,
    options: z.unknown().optional().nullable(),
    min_value: z.number().optional(),
    max_value: z.number().optional(),
    min_label: z.string().optional().nullable(),
    max_label: z.string().optional().nullable(),
    display_order: z.number().optional(),
    required: z.boolean().optional(),
    is_headline: z.boolean().optional(),
    created_at: z.date().optional(),
    customized_at: z.date().optional().nullable(),
    removed_at: z.date().optional().nullable(),
});
export const foodSensoryRoundQuestionMutator = z.object({
    id: foodSensoryRoundQuestionId.optional(),
    round_id: foodSensoryRoundId.optional(),
    source_question_id: foodSensoryQuestionId.optional().nullable(),
    test_type: foodSensoryTestType.optional(),
    text: z.string().optional(),
    question_type: foodSensoryQuestionType.optional(),
    options: z.unknown().optional().nullable(),
    min_value: z.number().optional(),
    max_value: z.number().optional(),
    min_label: z.string().optional().nullable(),
    max_label: z.string().optional().nullable(),
    display_order: z.number().optional(),
    required: z.boolean().optional(),
    is_headline: z.boolean().optional(),
    created_at: z.date().optional(),
    customized_at: z.date().optional().nullable(),
    removed_at: z.date().optional().nullable(),
});
//# sourceMappingURL=FoodSensoryRoundQuestion.js.map